import { Box, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
// import { relationships } from "../../../constants/constants";
import { PieChart } from "../Charts";
import SimpleBarReact from "simplebar-react";
import OtherRelations from "./OtherRelations";

import "./familyTree.scss";
import AddMemberModal from "../../../modals/yourAssets/FT/AddMemberModal";
import {
  getFamilyTree,
  updateAuditTrials,
} from "../../../services/yourAssets/FamilyTreeServices";
import { BASE_URL, FT_KEY, S3_URL, VERSION } from "../../../constants/ApiUrls";
import EditMemberModal from "../../../modals/yourAssets/FT/EditMemberModal";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getFTGraphCheck, setFTGraphCheck } from "../../../utils/Utilities";
import { useSelector } from "react-redux";

const FamilyBar = ({ trialsList }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const relationships = [
    { id: 1, name: t("relationship-1"), gender: "male" },
    { id: 2, name: t("relationship-2"), gender: "female" },
    { id: 3, name: t("relationship-3"), gender: "male" },
    { id: 4, name: t("relationship-4"), gender: "female" },
    { id: 5, name: t("relationship-5"), gender: "male" },
    { id: 6, name: t("relationship-6"), gender: "female" },
    { id: 7, name: t("relationship-7"), gender: "male" },
    { id: 8, name: t("relationship-8"), gender: "female" },
    { id: 9, name: t("relationship-9"), gender: "male" },
    { id: 10, name: t("relationship-10"), gender: "female" },
    { id: 11, name: t("relationship-11"), gender: "male" },
    { id: 12, name: t("relationship-12"), gender: "male" },
  ];

  const [addMemberModal, setAddMemberModal] = useState(false);
  const [currentNode, setCurrentNode] = useState({});
  const [defaultValue, setDefaultValue] = useState({});
  const [otherRelationsCard, setOtherRelationsCard] = useState(true);
  const [otherRelationships, setOtherRelationships] = useState([]);
  const [refreshTree, setRefreshTree] = useState(false);
  const [editMemberModal, setEditMemberModal] = useState(false);
  const [chartOptions, setChartOptions] = useState([]);
  const [auditTrialList, setAuditTrialList] = useState([]);

  const memoizedTrial = useMemo(() => trialsList, [trialsList]);

  const getTree = async () => {
    let result = await getFamilyTree(id);

    let changedObjects = [];
    for (let i = 0; i < trialsList.length; i++) {
      const elementI = trialsList[i];
      changedObjects.push(elementI.auditTrailId);
      for (let j = 0; j < result?.familyTree?.length; j++) {
        const elementJ = result?.familyTree[j];
        if (
          elementI.objectName === "UserFamilyTree" &&
          elementI.keyValues.ObjectId === elementJ.familyTreeId
        ) {
          elementJ.shadow = true;

          setAuditTrialList([...auditTrialList, elementI]);
        }
      }
    }
    if (changedObjects.length) {
      await updateAuditTrials(id, changedObjects);
    }
    for (let i = 0; i < result.familyTree.length; i++) {
      const element = result.familyTree[i];
      if (element.gender === "other") {
        element.gender = "female";
      }
      if (element.relationship !== "Pet" && element.relationship !== "Friend") {
        element.addNew = "/assets/icons/plus.png";
      }

      if (element.complicatedRelation && !element.isDead) {
        element.isAliveImage = "/assets/icons/bolt.png";
      } else if (element.isAlive && !element.complicatedRelation) {
        element.isAliveImage = "/assets/icons/cross.png";
      } else if (element.complicatedRelation && element.isDead) {
        element.isAliveImage = "/assets/icons/cross.png";
      }
      if (
        element.firstName &&
        element.dateOfBirth &&
        (element.relationship === "Pet" || element.relationship === "Friend")
      ) {
        element.edit = "/assets/icons/tick.png";
      } else {
        element.edit = "/assets/icons/edit.png";
      }

      if (!element.pictureId) {
        switch (element.relationship) {
          case "Pet":
            element.profilePicture = "/assets/icons/pet.png";
            break;
          case "Friend":
            element.profilePicture = "/assets/icons/friend.png";
            break;

          default:
            break;
        }
      } else {
        element.profilePicture =
          BASE_URL +
          FT_KEY +
          VERSION +
          id +
          "/familytree-image?familyTreeImageId=" +
          element.pictureId;
      }
    }
    let others = result?.familyTree.filter(
      (item) => item.relationship === "Pet" || item.relationship === "Friend"
    );
    let colors = ["#6b607e", "#444561", "#c298bb", "#957BA0"];

    let chartOpt = result?.inheritanceShares?.map((el, i) => {
      return {
        role: el.personName,
        color: colors[i % 4],
        series: el.personShares,
      };
    });

    setChartOptions(chartOpt);
    setRefreshTree(false);
    setOtherRelationships([...others]);
    setFTGraphCheck(false);
  };

  useEffect(() => {
    getTree();
  }, [memoizedTrial]);

  useEffect(() => {
    if (getFTGraphCheck()) getTree();
  }, [getFTGraphCheck()]);
  useEffect(() => {
    if (refreshTree) getTree();
  }, [refreshTree]);
  const handleClick = (item, key) => {
    setCurrentNode(JSON.parse(JSON.stringify(item)));
    for (let i = 0; i < relationships.length; i++) {
      const element = relationships[i];
      if (element.id === item.id) {
        setDefaultValue(element);
      }
    }
    if (key === "edit") {
      setEditMemberModal(true);
    } else if (key === "add") {
      setAddMemberModal(true);
    }
  };
  const style = {
    position: "absolute",
    top: 0,
    right: 0,
    width: "15px",
    cursor: "pointer",
  };
  const otherRelations = [
    {
      id: 11,
      name: t("relationship-11"),
      image: "pet.png",
    },
    {
      id: 12,
      name: t("relationship-12"),
      image: "friend.png",
    },
  ];
  return (
    <>
      <Box component="div" className="other-relations">
        <Box component="div" className="card-nav" sx={{ position: "relative" }}>
          <Typography variant="inherit" sx={{ p: 2 }}>
            {t("rm-type-7")}
          </Typography>
          <Box component="div" className="relations-head">
            {otherRelations.map((item) => (
              <Box component="div" sx={{ position: "relative" }}>
                <img
                  src="/assets/icons/plus.png"
                  alt="add"
                  style={style}
                  onClick={() => handleClick(item, "add")}
                />
                <img
                  src={"/assets/icons/" + item.image}
                  alt={item.name}
                  className="user-image"
                />
              </Box>
            ))}
          </Box>
          <img
            src="/assets/icons/down-arrow-1.png"
            alt="pet"
            className={otherRelationsCard ? "card-handle rotate-img" : "card-handle" }
            onClick={() => {
              setOtherRelationsCard(!otherRelationsCard);
            }}
          />
        </Box>
        <Box
          component="div"
          className="main-section"
          sx={{
            display: otherRelationsCard ? "block" : "none",
          }}
        >
          <SimpleBarReact style={{ height: '100%' }} autoHide={false}>
            <OtherRelations list={otherRelationships} click={handleClick} />
          </SimpleBarReact>
        </Box>
      </Box>
      <PieChart options={chartOptions || []} className="pie-chart-ft-adviser" />

      <EditMemberModal
        open={editMemberModal}
        handleClose={() => {
          setEditMemberModal(false);
        }}
        defaultValue={defaultValue}
        currentNode={currentNode}
        enableSelection={true}
        refresh={() => {
          setRefreshTree(true);
        }}
        userId={id}
      />

      <AddMemberModal
        open={addMemberModal}
        handleClose={() => {
          setAddMemberModal(false);
        }}
        currentNode={currentNode}
        defaultValue={defaultValue}
        enableSelection={true}
        refreshTree={() => {
          setRefreshTree(true);
        }}
        userId={id}
      />
    </>
  );
};

export default FamilyBar;
